module.exports = __webpack_public_path__ + "img/chevron-left.d0ca2f6b.svg";